<script>
// Dead-end state for the review screen: the link can't load a proof anymore
// (expired/revoked access, deleted proof). Renders inside the tenant's
// possibly-whitelabeled shell, so it stays visually quiet and routes the
// approver to the tenant by name.
export default {
  name: "reviewAccessDenied",
  props: {
    message: {
      type: String,
      default: "This review link is no longer active.",
    },
    accountName: {
      type: String,
      default: "",
    },
  },
};
</script>

<template>
  <div class="review-dead-end" role="status">
    <svg
      class="review-dead-end__art"
      viewBox="0 0 220 150"
      fill="none"
      aria-hidden="true"
    >
      <!-- paper boat, adrift -->
      <g class="review-dead-end__boat">
        <!-- hull -->
        <path
          d="M52 92 H168 L146 122 H74 Z"
          fill="#E2F1EA"
          stroke="#019255"
          stroke-width="3"
          stroke-linejoin="round"
        />
        <!-- sail -->
        <path
          d="M110 34 L110 92 M110 34 L74 92 H110 M110 34 L146 92 H110"
          fill="#FFFFFF"
          stroke="#019255"
          stroke-width="3"
          stroke-linejoin="round"
        />
      </g>
      <!-- water -->
      <path
        class="review-dead-end__wave"
        d="M24 132 Q39 124 54 132 T84 132 T114 132 T144 132 T174 132 T204 132"
        stroke="#019255"
        stroke-width="3"
        stroke-linecap="round"
        opacity="0.45"
      />
      <path
        class="review-dead-end__wave review-dead-end__wave--far"
        d="M44 144 Q59 137 74 144 T104 144 T134 144 T164 144"
        stroke="#019255"
        stroke-width="3"
        stroke-linecap="round"
        opacity="0.2"
      />
    </svg>
    <h2 class="review-dead-end__title">{{ message }}</h2>
    <p class="review-dead-end__help">
      <template v-if="accountName">
        Contact <strong>{{ accountName }}</strong> to get a new review link.
      </template>
      <template v-else>
        Contact the person who sent you this proof to get a new review link.
      </template>
    </p>
  </div>
</template>

<style scoped>
.review-dead-end {
  height: 100%;
  min-height: 320px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 24px;
}

.review-dead-end__art {
  width: 172px;
  height: auto;
  margin-bottom: 28px;
}

.review-dead-end__boat {
  animation: review-dead-end-bob 4.5s ease-in-out infinite;
  transform-origin: 110px 92px;
}

@keyframes review-dead-end-bob {
  0%,
  100% {
    transform: translateY(0) rotate(0deg);
  }
  50% {
    transform: translateY(4px) rotate(-1.5deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .review-dead-end__boat {
    animation: none;
  }
}

.review-dead-end__title {
  font-size: 22px;
  font-weight: 600;
  color: #3e3e40;
  margin: 0 0 10px;
  max-width: 440px;
}

.review-dead-end__help {
  font-size: 15px;
  color: #75757a;
  margin: 0;
  max-width: 400px;
  line-height: 1.5;
}

.review-dead-end__help strong {
  font-weight: 600;
  color: #3e3e40;
}
</style>
